export default __webpack_public_path__ + "static/media/cont.ed62b2af.jpg";